import React from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';


export function OutlinedCard({ type, name, price, desc }) {
    const card = (
        <React.Fragment>
            <CardContent>
                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 12 }}>
                    {type ?? 'Standard Widget'}
                </Typography>
                <Typography variant="h5" component="div">
                    {name ?? 'Widget Name'}
                </Typography>
                <Stack direction="row" spacing={1}>
                    <Chip
                        label={price || 'In My Widgets'}
                        color="success"
                        variant="outlined"
                        size="small"
                        icon={price ? null : <CheckOutlinedIcon/>}
                    />
                </Stack>
                <Typography variant="body2">
                    <br/>
                    {desc ?? 'A brief description of what this widget does.'}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small">Learn More</Button>
            </CardActions>
        </React.Fragment>
    );

    return (
        <Box sx={{ minWidth: 275 }}>
            <Card variant="outlined">{card}</Card>
        </Box>
    );
}

export function OutlinedActionCard({ type, nav, icon, name, price, desc, buttonText }) {
    const navigate = useNavigate();

    const card = (
        <React.Fragment>
            <CardActionArea src="" onClick={() => navigate(nav)} sx={{ cursor: 'pointer' }} color="inherit">
                <CardContent>
                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 12 }}>
                        {type ?? 'Standard Widget'}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                        {icon ?? <CategoryOutlinedIcon />}
                        <Typography variant="h5" component="div">
                            {name ?? 'Widget Name'}
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        {price !== null && <Chip
                            label={price || 'In My Widgets'}
                            color="success"
                            variant="outlined"
                            size="small"
                            icon={price ? null : <CheckOutlinedIcon />}
                        />}
                    </Stack>
                    <Typography variant="body2">
                        <br/>
                        {desc ?? 'A brief description of what this widget does.'}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small">{buttonText ?? "Learn More"}</Button>
                </CardActions>
            </CardActionArea>
        </React.Fragment>
    );

    return (
        <Box sx={{ minWidth: 275 }}>
            <Card variant="outlined">{card}</Card>
        </Box>
    );
}
